import { Timestamp } from 'types'

export const getStartOfHour = (date: Date | Timestamp) => {
  const newDate = new Date(date)

  newDate.setMinutes(0, 0, 0)

  return newDate.getTime()
}
